import request from '../utils/request'

// 登录
export function login(data) {
  return request({
    url: '/api-uaa/oauth/token',
    method: 'post',
    transformRequest: [function(data) {
      let ret = ''
      for (const it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      ret = ret.substring(0, ret.length - 1)
      return ret
    }],
    data
  })
}

// 用户信息
export function getInfo() {
  return request({
    url: '/api-study/users/current',
    method: 'get',
  })
}
// 验证
export function checkToken(data) {
  return request({
    url: '/api-uaa/oauth/check_token?token=' + data,
    method: 'post'
  })
}

// 退出
export function logout(data) {
  return request({
    url: 'api-uaa/oauth/remove/token?access_token=' + data,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js